import type { RouteObject } from 'react-router';

import { tenantLoader } from './tenant-loader';
import { discountsRoutes } from './discounts';
import { pricesRoutes } from './prices';
import { limitTemplatesRoutes } from './limit-templates';
import { usersRoutes } from './users';
import { checkoutRoutes } from './checkout';
import { couponsRoutes } from './coupons';
import { debtorsRoutes } from './debtors';
import { ordersRoutes } from './orders';
import { driversRoutes } from './drivers';
import { cardsRoutes } from './cards';
import { contractsRoutes } from './contracts';

// TODO: migrate tenant URL paths '/admin/*' → '/tenant/*' for naming consistency
// with the renamed bucket. Scope (FRONTEND ONLY):
//   - segment route paths: tenant/{discounts,prices,limit-templates,users,coupons,checkout}/*-routes.tsx
//   - nav links: widgets/layout/config/admin-navigation-items.tsx
//   - navigate('/admin/...') calls in pages/admin/*
// DO NOT touch backend API endpoints (httpClient.get('/admin/...') in entities/*/api,
// features/*/api) — those are the server contract, unrelated to frontend routing.
export const tenantRoutes: RouteObject = {
  loader: tenantLoader,
  children: [
    { path: '/tenant', Component: () => 'Tenant' },
    discountsRoutes,
    pricesRoutes,
    limitTemplatesRoutes,
    usersRoutes,
    checkoutRoutes,
    couponsRoutes,
    debtorsRoutes,
    ordersRoutes,
    driversRoutes,
    cardsRoutes,
    contractsRoutes,
  ],
};
